// extracted by mini-css-extract-plugin
export default {"container":"SmallLoader_container__w+rcb","spinner":"SmallLoader_spinner__NxO6t","spinner-d3wgkg":"SmallLoader_spinner-d3wgkg__5E8hf"};